import withMetadataArgument from './withMetadataArgument.js'
import { parsePhoneNumberWithError as _parsePhoneNumberWithError } from '../../core/index.js'

export function parsePhoneNumberWithError() {
	return withMetadataArgument(_parsePhoneNumberWithError, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/parsePhoneNumberWithError.js
// module id = 1623
// module chunks = 0